<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

<div class="bdf">
  <div class="bdf__card">
    <header class="bdf__head">
      <img
        class="bdf__head-icon"
        src="assets/image/budgetform/create-budget.svg"
        alt=""
        width="40"
        height="40"
        aria-hidden="true"
      />
      <div class="bdf__head-text">
        <h1 class="bdf__title">{{ isEditingBudget ? 'Update Budget' : 'Create Budget' }}</h1>
        <p class="bdf__subtitle">{{ isEditingBudget ? 'Enter new values to update this budget plan' : 'Fill in the details to create a new budget plan' }}</p>
      </div>
    </header>

    <section class="bdf__sec" aria-labelledby="bdf-org">
      <div class="bdf__sec-head">
        <img
          src="assets/image/budgetform/organization-details.svg"
          alt=""
          width="22"
          height="22"
          aria-hidden="true"
        />
        <h2 id="bdf-org" class="bdf__sec-title">Organization Details</h2>
      </div>

      <div class="bdf__grid">
        <div class="bdf__fld">
          <label class="bdf__lbl" for="bdf-campus">Campus Name</label>
          <div class="bdf__control" [class.bdf__control--select]="!isEditingBudget" #campusControl>
            <img
              class="bdf__fld-icon"
              src="assets/image/budgetform/campus.svg"
              alt=""
              aria-hidden="true"
            />
            <span *ngIf="isEditingBudget" class="bdf__bound-val" [class.bdf__bound-val--empty]="!campus2.value">
              {{ campus2.value || '—' }}
            </span>
            <mat-select
              *ngIf="!isEditingBudget"
              id="bdf-campus"
              class="bdf__mat-select"
              placeholder="Select campus"
              panelClass="bdf-select-panel"
              disableOptionCentering
              [formControl]="campus2"
              (selectionChange)="onCampusSelectionChange($event)"
              (openedChange)="alignSelectPanel($event, campusControl)"
            >
              <input
                matInput
                [matAutocomplete]="campusAuto"
                [formControl]="campus"
                class="bdf__mat-select-input"
                placeholder="Enter campus name to select"
              />
              <mat-autocomplete autoActiveFirstOption #campusAuto="matAutocomplete"></mat-autocomplete>
              <mat-option
                *ngFor="let item of campusOptions | async; trackBy: trackByCampusId"
                [value]="item?.campusName"
              >
                {{ item?.campusName }}
              </mat-option>
            </mat-select>
          </div>
        </div>

        <div class="bdf__fld">
          <label class="bdf__lbl">Fusion Campus Code</label>
          <div class="bdf__control">
            <img
              class="bdf__fld-icon"
              src="assets/image/budgetform/campus.svg"
              alt=""
              aria-hidden="true"
            />
            <span class="bdf__bound-val" [class.bdf__bound-val--empty]="!fusionCampusCode.value">
              {{ fusionCampusCode.value || '—' }}
            </span>
          </div>
        </div>

        <div class="bdf__fld">
          <label class="bdf__lbl" for="bdf-teach-type">Teaching Type</label>
          <div class="bdf__control" [class.bdf__control--select]="!isEditingBudget" #teachTypeControl>
            <img
              class="bdf__fld-icon"
              src="assets/image/budgetform/teaching-type.svg"
              alt=""
              aria-hidden="true"
            />
            <span *ngIf="isEditingBudget" class="bdf__bound-val" [class.bdf__bound-val--empty]="!teachingType2.value">
              {{ teachingType2.value || '—' }}
            </span>
            <mat-select
              *ngIf="!isEditingBudget"
              id="bdf-teach-type"
              class="bdf__mat-select"
              placeholder="Select teaching type"
              panelClass="bdf-select-panel"
              disableOptionCentering
              [formControl]="teachingType2"
              (selectionChange)="onTeachingTypeSelectionChange($event)"
              (openedChange)="alignSelectPanel($event, teachTypeControl)"
            >
              <input
                matInput
                [matAutocomplete]="teachTypeAuto"
                [formControl]="teachingType"
                class="bdf__mat-select-input"
                placeholder="Enter teaching type to select"
              />
              <mat-autocomplete autoActiveFirstOption #teachTypeAuto="matAutocomplete"></mat-autocomplete>
              <mat-option
                *ngFor="let item of teachingTypeOptions | async"
                [value]="item?.roleType || item?.TeachType"
              >
                {{ item?.roleType || item?.TeachType }}
              </mat-option>
            </mat-select>
          </div>
        </div>

        <div class="bdf__fld">
          <label class="bdf__lbl" for="bdf-dept">Department</label>
          <div class="bdf__control" [class.bdf__control--select]="!isEditingBudget" #deptControl>
            <img
              class="bdf__fld-icon"
              src="assets/image/budgetform/department.svg"
              alt=""
              aria-hidden="true"
            />
            <span *ngIf="isEditingBudget" class="bdf__bound-val" [class.bdf__bound-val--empty]="!department2.value">
              {{ department2.value || '—' }}
            </span>
            <mat-select
              *ngIf="!isEditingBudget"
              id="bdf-dept"
              class="bdf__mat-select"
              placeholder="Select department"
              panelClass="bdf-select-panel"
              disableOptionCentering
              [formControl]="department2"
              (openedChange)="alignSelectPanel($event, deptControl)"
            >
              <input
                matInput
                [matAutocomplete]="deptAuto"
                [formControl]="department"
                class="bdf__mat-select-input"
                placeholder="Enter department to select"
              />
              <mat-autocomplete autoActiveFirstOption #deptAuto="matAutocomplete"></mat-autocomplete>
              <mat-option
                *ngFor="let item of departmentOptions | async"
                [value]="item?.deptName ?? item?.departmentName"
              >
                {{ item?.deptName ?? item?.departmentName }}
              </mat-option>
            </mat-select>
          </div>
        </div>

        <div class="bdf__fld">
          <label class="bdf__lbl" for="bdf-desig">Designation</label>
          <div class="bdf__control" [class.bdf__control--select]="!isEditingBudget" #desigControl>
            <img
              class="bdf__fld-icon"
              src="assets/image/budgetform/designation.svg"
              alt=""
              aria-hidden="true"
            />
            <span *ngIf="isEditingBudget" class="bdf__bound-val" [class.bdf__bound-val--empty]="!organizationDesignationLabel">
              {{ organizationDesignationLabel || '—' }}
            </span>
            <mat-select
              *ngIf="!isEditingBudget"
              id="bdf-desig"
              class="bdf__mat-select"
              placeholder="Select designation"
              panelClass="bdf-select-panel bdf-select-panel--designation"
              disableOptionCentering
              [formControl]="designation2"
              (openedChange)="alignSelectPanel($event, desigControl)"
              (selectionChange)="onDesignationSelectionChange($event)"
            >
              <input
                matInput
                [matAutocomplete]="desigAuto"
                [formControl]="designation"
                class="bdf__mat-select-input"
                placeholder="Enter designation to select"
              />
              <mat-autocomplete autoActiveFirstOption #desigAuto="matAutocomplete"></mat-autocomplete>
              <mat-option
                *ngFor="let item of designationOptions | async; trackBy: trackByDesigId"
                [value]="item?.desigId ?? item?.id"
              >
                {{ item?.desigName ?? item?.designation }}
              </mat-option>
            </mat-select>
          </div>
        </div>

        <div class="bdf__fld" *ngIf="showSubjectSelection">
          <label class="bdf__lbl" for="bdf-subject">Subject</label>
          <div class="bdf__control" [class.bdf__control--select]="!isEditingBudget" #subjectControl>
            <img
              class="bdf__fld-icon"
              src="assets/image/budgetform/subject.svg"
              alt=""
              aria-hidden="true"
            />
            <span *ngIf="isEditingBudget" class="bdf__bound-val" [class.bdf__bound-val--empty]="!subject2.value">
              {{ subject2.value || '—' }}
            </span>
            <mat-select
              *ngIf="!isEditingBudget"
              id="bdf-subject"
              class="bdf__mat-select"
              placeholder="Select subject"
              panelClass="bdf-select-panel"
              disableOptionCentering
              [formControl]="subject2"
              (openedChange)="alignSelectPanel($event, subjectControl)"
            >
              <input
                matInput
                [matAutocomplete]="subjectAuto"
                [formControl]="subject"
                class="bdf__mat-select-input"
                placeholder="Enter subject to select"
              />
              <mat-autocomplete autoActiveFirstOption #subjectAuto="matAutocomplete"></mat-autocomplete>
              <mat-option
                *ngFor="let item of subjectOptions | async"
                [value]="item?.subName ?? item?.subjectName"
              >
                {{ item?.subName ?? item?.subjectName }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </div>
    </section>

    <section class="bdf__sec" aria-labelledby="bdf-budget">
      <div class="bdf__sec-head">
        <img
          src="assets/image/budgetform/budget-details.svg"
          alt=""
          width="22"
          height="22"
          aria-hidden="true"
        />
        <h2 id="bdf-budget" class="bdf__sec-title">Budget Details</h2>
      </div>

      <p class="bdf__hint">
        Budget Amount and salary fields are monthly values.
      </p>

      <div class="bdf__grid">
        <div class="bdf__fld">
          <label class="bdf__lbl" for="bdf-amount">{{ budgetAmountFieldLabel }}</label>
          <div class="bdf__control" [class.bdf__control--error]="!!budgetAmountError">
            <img
              class="bdf__fld-icon"
              src="assets/image/budgetform/budget-amount.svg"
              alt=""
              aria-hidden="true"
            />
            <input
              id="bdf-amount"
              class="bdf__inp"
              type="text"
              inputmode="numeric"
              [placeholder]="budgetAmountPlaceholder"
              [formControl]="budgetAmount"
              (input)="onNumericInput(budgetAmount, $event, true, true)"
            />
          </div>
          <p
            class="bdf__amount-change"
            *ngIf="budgetAmountChangeLabel"
            [class.bdf__amount-change--up]="budgetAmountChangeTone === 'up'"
            [class.bdf__amount-change--down]="budgetAmountChangeTone === 'down'"
          >{{ budgetAmountChangeLabel }}</p>
          <p class="bdf__field-error" *ngIf="budgetAmountError">{{ budgetAmountError }}</p>
        </div>

        <div class="bdf__fld">
          <label class="bdf__lbl" for="bdf-emp-count">Employee Count</label>
          <div class="bdf__control" [class.bdf__control--error]="!!employeeCountError">
            <img
              class="bdf__fld-icon"
              src="assets/image/budgetform/employee-count.svg"
              alt=""
              aria-hidden="true"
            />
            <input
              id="bdf-emp-count"
              class="bdf__inp"
              type="text"
              inputmode="numeric"
              [placeholder]="isEditingBudget ? 'Enter increase count or -decrease count' : 'Enter employee count'"
              [formControl]="employeeCount"
              (input)="onNumericInput(employeeCount, $event, false, isEditingBudget)"
            />
          </div>
          <p class="bdf__amount-change" *ngIf="isEditingBudget">
            No. of Positions: {{ originalEmployeeCount ?? '—' }}
          </p>
          <p class="bdf__field-error" *ngIf="employeeCountError">{{ employeeCountError }}</p>
        </div>

        <div class="bdf__fld">
          <label class="bdf__lbl" for="bdf-min-salary">Monthly Min Salary</label>
          <div class="bdf__control" [class.bdf__control--error]="!!minSalaryError">
            <img
              class="bdf__fld-icon"
              src="assets/image/budgetform/min-max-salary.svg"
              alt=""
              aria-hidden="true"
            />
            <input
              id="bdf-min-salary"
              class="bdf__inp"
              type="text"
              inputmode="numeric"
              placeholder="Min 5,000 per month"
              [formControl]="minSalary"
              (input)="onNumericInput(minSalary, $event, true)"
              (blur)="fillBlankSalaryFields()"
            />
          </div>
          <p class="bdf__field-error" *ngIf="minSalaryError">{{ minSalaryError }}</p>
        </div>

        <div class="bdf__fld">
          <label class="bdf__lbl" for="bdf-max-salary">Monthly Max Salary</label>
          <div class="bdf__control" [class.bdf__control--error]="!!maxSalaryError">
            <img
              class="bdf__fld-icon"
              src="assets/image/budgetform/min-max-salary.svg"
              alt=""
              aria-hidden="true"
            />
            <input
              id="bdf-max-salary"
              class="bdf__inp"
              type="text"
              inputmode="numeric"
              placeholder="Enter max monthly salary"
              [formControl]="maxSalary"
              (input)="onNumericInput(maxSalary, $event, true)"
              (blur)="fillBlankSalaryFields()"
            />
          </div>
          <p class="bdf__field-error" *ngIf="maxSalaryError">{{ maxSalaryError }}</p>
        </div>

        <div class="bdf__fld">
          <label class="bdf__lbl" for="bdf-avg-salary">Monthly Avg Salary</label>
          <div class="bdf__control" [class.bdf__control--error]="!!avgSalaryError">
            <img
              class="bdf__fld-icon"
              src="assets/image/budgetform/avg-salary.svg"
              alt=""
              aria-hidden="true"
            />
            <input
              id="bdf-avg-salary"
              class="bdf__inp"
              type="text"
              inputmode="numeric"
              placeholder="Enter avg monthly salary"
              [formControl]="avgSalary"
              (input)="onNumericInput(avgSalary, $event, true)"
              (blur)="fillBlankSalaryFields()"
            />
          </div>
          <p class="bdf__field-error" *ngIf="avgSalaryError">{{ avgSalaryError }}</p>
        </div>

        <div class="bdf__fld">
          <label class="bdf__lbl">Budget Year</label>
          <div class="bdf__control">
            <img
              class="bdf__fld-icon"
              src="assets/image/budgetform/budget-details.svg"
              alt=""
              aria-hidden="true"
            />
            <span class="bdf__bound-val" [class.bdf__bound-val--empty]="!budgetYear.value">
              {{ budgetYear.value || '—' }}
            </span>
          </div>
        </div>

        <div class="bdf__fld bdf__fld--full">
          <label class="bdf__lbl" for="bdf-remarks">Remarks</label>
          <div class="bdf__control bdf__control--textarea">
            <textarea
              id="bdf-remarks"
              class="bdf__ta"
              rows="3"
              placeholder="e.g. Budget Approved for Academic Year 2026-27"
              [formControl]="remarks"
            ></textarea>
          </div>
        </div>
      </div>
    </section>

    <footer class="bdf__actions">
      <button type="button" class="bdf__btn bdf__btn--back" (click)="goToBudgetReport()">
        Back
      </button>
      <button type="button" class="bdf__btn bdf__btn--reset" (click)="resetForm()">
        <img src="assets/image/budgetform/reset.svg" alt="" width="14" height="14" aria-hidden="true" />
        Reset
      </button>
      <button type="button" class="bdf__btn bdf__btn--submit" (click)="submitBudget()" [disabled]="isSaving">
        <img src="assets/image/budgetform/check.svg" alt="" width="14" height="14" aria-hidden="true" />
        {{ isSaving ? 'Submitting...' : (isEditingBudget ? 'Update Budget' : 'Submit Budget') }}
      </button>
    </footer>
  </div>
</div>
